<template>
<!--  <div class="button" @click="showModal()">登録して完了</div>-->
  <div class="form formSignupComplete">
    <div class="box">
      <div class="contents">
        <div class="complete">
          <div class="icon"></div>
          <h3>登録が完了しました</h3>
          <p>引き続きALOCOをお楽しみください</p>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      show: false,
    };
  },
  methods: {
    showModal() {
      this.show = true;
    },
    closeModal() {
      this.show = false;
    },
    pageTransition() {
      window.location.href = "/";
    },
  },
};
</script>
